
import { Component, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'

@Component({})
export default class extends AbpBase {
  name: string = 'home'

  get menuList() {
    return this.$store.state.app.menuList
  }

  @Watch('menuList', { immediate: false, deep: true })
  onMenuListChanged(menuList) {
    // 查找第一个菜单，replace过去
    if (!menuList || !menuList.length) {
      this.$router.replace({
        name: 'Error'
      })
      return
    }
    let toRoute
    let activeName = ''
    if (menuList[0] && menuList[0].children && menuList[0].children.length) {
      toRoute = menuList[0].children[0]
    } else {
      toRoute = menuList[0].name
    }
    activeName = !toRoute.path ? menuList[0].name : toRoute.name
    // 有children
    this.$store.commit('app/setActiveMenuName', activeName)
    this.$router.replace({
      name: toRoute.name
    })
  }
}
